// Dynamically update product price on variant change
// Requires: product JSON in <script id="ProductJson-{{ product.id }}"> and price container with .product-info__price

document.addEventListener('DOMContentLoaded', function() {
  // If VIP price data exists, vip-loyalty.js handles variant price updates
  if (document.getElementById('vip-price-data')) return;

  var productJsonScript = document.getElementById('ProductJson-' + window.productId);
  if (!productJsonScript) {
    // Try to find any product JSON
    productJsonScript = document.querySelector('[id^="ProductJson-"]');
  }
  if (!productJsonScript) return;

  var productData = JSON.parse(productJsonScript.textContent || productJsonScript.innerText);
  if (!productData || !productData.variants) return;

  // Try to get the select element for variants
  var variantSelect = document.querySelector('select[name="id"]');
  if (!variantSelect) return;

  variantSelect.addEventListener('change', function(e) {
    var selectedId = parseInt(variantSelect.value, 10);
    var variant = productData.variants.find(function(v) { return v.id === selectedId; });
    if (!variant) return;

    // Format price (Shopify outputs cents)
    var price = (variant.price / 100).toLocaleString(undefined, { style: 'currency', currency: productData.currency || 'USD' });
    var compareAtPrice = variant.compare_at_price ? (variant.compare_at_price / 100).toLocaleString(undefined, { style: 'currency', currency: productData.currency || 'USD' }) : '';

    // Update price container with original theme markup and classes
    var priceContainer = document.querySelector('.product-info__price');
    if (priceContainer) {
      var isOnSale = compareAtPrice && compareAtPrice !== price;
      var priceHtml =
        '<div class="price' + (isOnSale ? ' price--on-sale' : '') + '">' +
          '<div class="price__default">' +
            '<span class="price__current">' + price + '</span>' +
            (isOnSale ? '<span class="price__was">' + compareAtPrice + '</span>' : '') +
          '</div>' +
        '</div>';
      priceContainer.innerHTML = priceHtml;
    }
  });
});

// Set window.productId for this product page
(function() {
  var productJson = document.querySelector('[id^="ProductJson-"]');
  if (productJson) {
    var idMatch = productJson.id.match(/ProductJson-(\d+)/);
    if (idMatch) window.productId = idMatch[1];
  }
})();
